<template>
  <div class="bg-white rounded-sm text-gray mx-2 my-3">
    <div class="grid grid-cols-12 gap-4">
      <div class="col-span-12">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
// This is a simple wrapper component that displays the router-view for nested account routes
// No state management or logic is needed here
</script>

